import { render, staticRenderFns } from "./krTermsPopup.vue?vue&type=template&id=569d64ce&scoped=true&"
import script from "./krTermsPopup.vue?vue&type=script&lang=js&"
export * from "./krTermsPopup.vue?vue&type=script&lang=js&"
import style0 from "./krTermsPopup.vue?vue&type=style&index=0&id=569d64ce&prod&lang=scss&"
import style1 from "./krTermsPopup.vue?vue&type=style&index=1&id=569d64ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569d64ce",
  null
  
)

export default component.exports